module.exports = __webpack_public_path__ + "img/logo.a5092dd8.svg";